import { render } from "./AdDocumentViewLikesList.vue?vue&type=template&id=7ed3dbf0&ts=true"
import script from "./AdDocumentViewLikesList.vue?vue&type=script&lang=ts"
export * from "./AdDocumentViewLikesList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__